import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { formatTimestamp } from './widgetUtils';

import widgetWrapper from './widgetWrapper';

import './ListWidget.scss';

class ThreeSlotListWidget extends Component {

  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    details: PropTypes.string,
    align: PropTypes.string,
    list: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.shape({
        className: PropTypes.string,
        label: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        value2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      })),
      sortBy: PropTypes.string,
    }),
    timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
  };

  static defaultProps = {
    title: '',
    subtitle: '',
    details: '',
    timestamp: '',
    align: '',
    className: '',
    list: {
      items: [],
      sortBy: null,
    },
  };

  render() {

    const {
      title,
      subtitle,
      details,
      timestamp,
      align,
      className,
      list: {
        items,
        sortBy,
      },
    } = this.props;

    // _.zipObject(keys, _.map(keys, function() { }));
    const listClasses = classnames({
      list: true,
      'align-top': (align === 'top'),
      'align-bottom': (align === 'bottom'),
    });

    return (
      <div className={`widget-threshold-colors ListWidget ${className}`}>
        <div className="header">
          <div className="title">{title}</div>
          <div className="subtitle">{subtitle}</div>
        </div>
        <div className="content">
          <ul className={listClasses}>
            {
              (sortBy
                ? items.sort((a, b) => (a[sortBy] - b[sortBy]))
                : items)
                .map(item => (
                  <li
                    className={item.className ? item.className : null}
                    key={`L${item.label}-V${item.value}-V2${item.value2}`}
                  >
                    <span className="label" title={`${item.label}`}>{item.label}</span>
                    <span className="value">{item.value}</span>
                    <span className="value">{item.value2}</span>
                  </li>
                ))
            }
          </ul>
        </div>
        <div className="footer">
          <div className="details">{details}</div>
          <div className="timestamp">{formatTimestamp(timestamp)}</div>
        </div>
      </div>
    );
  }
}

export default widgetWrapper(ThreeSlotListWidget);
